//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RewardCardItem from '~/components/gold-points/RewardCardItem'

export default {
  components: { RewardCardItem },
  data() {
    return {
      list: [],
      loadingProduct: false,
      isLoading: false,
      params: {
        limit: 9,
        page: 1,
        is_active: 1,
      },
      lastMeta: null,
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.loadingProduct = true
        const response = await this.$axios.get(`v1/product-rewards`, {
          params: this.params,
        })
        const data = response.data
        this.lastMeta = {
          current_page: data.current_page,
          last_page: data.last_page,
          next_page_url: data.next_page_url,
        }
        this.list = data.data
        this.loadingProduct = false
      } catch (err) {
        this.loadingProduct = false
        this.$alert.requestError(err)
      }
    },
    async loadMore() {
      if (
        this.lastMeta &&
        this.lastMeta.current_page === this.lastMeta.last_page
      ) {
        return
      }

      try {
        this.isLoading = true
        const page = (this.lastMeta && this.lastMeta.current_page + 1) || 1
        const response = await this.$axios.get(`v1/product-rewards`, {
          params: { ...this.params, page },
        })
        const data = response.data
        this.list = [...this.list, ...data.data]
        this.lastMeta = {
          current_page: data.current_page,
          last_page: data.last_page,
          next_page_url: data.next_page_url,
        }
        this.isLoading = false
      } catch (err) {
        this.$alert.requestError(err)
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
  },
}
